/** Media Session API wiring — drives lock-screen / CarPlay / notification controls. */

import { useAudioBibleStore } from '../stores/audioBibleStore'
import { getBookById } from './bibleBooks'

export function updateMediaSession() {
  if (!('mediaSession' in navigator)) return
  const state = useAudioBibleStore.getState()
  if (!state.bookId || !state.chapter) {
    try {
      navigator.mediaSession.metadata = null
    } catch {
      /* ignore */
    }
    return
  }

  const book = getBookById(state.bookId)
  const bookName = book?.name ?? state.bookId

  navigator.mediaSession.metadata = new MediaMetadata({
    title: `${bookName} ${state.chapter}`,
    artist: state.translation,
    album: 'Scrivaro',
    artwork: [
      { src: '/icon-512.png', sizes: '512x512', type: 'image/png' },
      { src: '/icon-192.png', sizes: '192x192', type: 'image/png' },
    ],
  })

  try {
    navigator.mediaSession.setPositionState?.({
      duration: state.totalDurationSec || 0,
      playbackRate: state.speed,
      position: Math.min(state.currentPositionSec, state.totalDurationSec || 0),
    })
  } catch {
    /* invalid state — ignore */
  }

  navigator.mediaSession.setActionHandler('play', () => {
    useAudioBibleStore.getState().resume()
  })
  navigator.mediaSession.setActionHandler('pause', () => {
    useAudioBibleStore.getState().pause()
  })
  navigator.mediaSession.setActionHandler('seekto', (details) => {
    if (details.seekTime != null) useAudioBibleStore.getState().seek(details.seekTime)
  })
}

export function registerMediaSessionSubscriber() {
  if (!('mediaSession' in navigator)) return () => {}
  const unsub = useAudioBibleStore.subscribe((state, prev) => {
    if (
      state.bookId !== prev.bookId ||
      state.chapter !== prev.chapter ||
      state.totalDurationSec !== prev.totalDurationSec ||
      state.speed !== prev.speed
    ) {
      updateMediaSession()
    }
  })
  updateMediaSession()
  return unsub
}
